export enum CareTemplateTab {
  WardRoundsSchedule,
  Vitality,
}
